import Vue from "vue";
import VueRouter from "vue-router";
import LoginLayout from "../views/layout/layout-login.vue";
import BaseLayout from "../views/layout/layout-base.vue";
import store from "../store";
import axios from "axios";

Vue.use(VueRouter);

function guard(to, from, next) {
    if (store.state.autenticado == "true" || store.state.autenticado) {
        axios.defaults.headers.Authorization = store.state.accessToken;
        next();
    } else {
        next("/");
    }
}

function verifyAutenticado(to, from, next) {
    next();
}

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes: [{
            path: "/",
            name: "login",
            meta: { layout: LoginLayout },
            component: () =>
                import ("../views/Login.vue"),
            beforeEnter: verifyAutenticado
        },
        {
            path: "/index",
            name: "index",
            meta: { layout: BaseLayout },
            component: () =>
                import ("../views/Index.vue"),
            beforeEnter: guard
        },
        {
            path: "/infoCurso/:idCurso",
            name: "infoCurso",
            meta: { layout: BaseLayout },
            component: () =>
                import ("../views/infoCurso.vue"),
            beforeEnter: guard
        },
        {
            path: "/busquedaAlumno",
            name: "busquedaAlumno",
            meta: { layout: BaseLayout },
            component: () =>
                import ("../views/busquedaAlumno.vue"),
            beforeEnter: guard
        },
        {
            path: "/info-evaluacion/:idEvaluacion",
            name: "info-evaluacion",
            meta: { layout: BaseLayout },
            component: () =>
                import ("../views/infoEvaluacion.vue"),
            beforeEnter: guard
        },
        {
            path: "/reinicio-nota/:idCurso",
            name: "reinicio-nota",
            meta: { layout: BaseLayout },
            component: () =>
                import ("../views/reinicioEvaluacion.vue"),
            beforeEnter: guard
        },
        {
            path: "/evaluacion-curso",
            name: "evaluacion-curso",
            meta: { layout: BaseLayout },
            component: () =>
                import ("../views/evaluacionCurso.vue"),
            beforeEnter: guard
        },
        {
            path: "/evaluacion-alumno/:idEvaluacion/:idAlumno",
            name: "evaluacion-alumno",
            meta: { layout: BaseLayout },
            component: () =>
                import ("../views/evaluacionAlumno.vue"),
            beforeEnter: guard
        },
        {
            path: "/infoAlumno/:idAlumno",
            name: "infoAlumno",
            meta: { layout: BaseLayout },
            component: () =>
                import ("../views/infoAlumno.vue"),
            beforeEnter: guard
        },
        {
            path: "/biblioteca",
            name: "biblioteca",
            meta: { layout: BaseLayout },
            component: () =>
                import ("../views/biblioteca.vue"),
            beforeEnter: guard
        },
        {
            path: '/certificado',
            name: "certificado",
            meta: { layout: BaseLayout },
            component: () =>
                import ('../views/certificado.vue'),
            beforeEnter: guard
        },
        {
            path: '/historial/:id',
            name: "historial",
            meta: { layout: BaseLayout },
            component: () =>
                import ('../views/historial.vue'),
            beforeEnter: guard
        },
        {
            path: '/reportes',
            name: "reportes",
            meta: { layout: BaseLayout },
            component: () =>
                import ('../views/reportes.vue'),
            beforeEnter: guard
        }, 
        {
            path: '/dashboard',
            name: "dashboard",
            meta: { layout: BaseLayout },
            component: () =>
                import ('../views/dashboard.vue'),
            beforeEnter: guard
        }
    ]
});

router.beforeEach((to, from, next) => {
    /** Se intercepta cada petición axios y se controla el error 401, para alumnos que perdieron la vigencia de dsu token **/
    axios.interceptors.response.use(
        function(response) {
            return response;
        },
        function(error) {
            if (error.response.status == 401) {
                return next("/");
            }
        }
    );

    return next();
});

export default router;